// Fleet Pulse - shared normalisation & matching helpers

/** Strip everything except digits, return as a string. Empty string for nullish. */
export function normalizeClientNumber(value: unknown): string {
  if (value === null || value === undefined) return "";
  const s = String(value);
  return s.replace(/\D+/g, "");
}

/** Extract the numeric portion of a TaxiCaller / CRM cost code. */
export function extractTmClientNumberFromCostCode(value: unknown): string {
  if (value === null || value === undefined) return "";
  const s = String(value);
  return s.replace(/\D+/g, "");
}

/** TMClient or TMHClient (case-insensitive). */
export function isTotalMobilityCostCode(value: unknown): boolean {
  if (value === null || value === undefined) return false;
  const s = String(value).toLowerCase();
  return s.includes("tmclient") || s.includes("tmhclient");
}

/** TMHClient only (hoist). */
export function isHoistClientCostCode(value: unknown): boolean {
  if (value === null || value === undefined) return false;
  return String(value).toLowerCase().includes("tmhclient");
}

/** Returns true if the cost code uses the TMH (hoist) prefix. */
export function getCostCodePrefix(value: unknown): "TMH" | "TM" | "OTHER" | "NONE" {
  if (value === null || value === undefined) return "NONE";
  const s = String(value).toLowerCase();
  if (!s.trim()) return "NONE";
  if (s.includes("tmhclient")) return "TMH";
  if (s.includes("tmclient")) return "TM";
  return "OTHER";
}

/** Build the *expected* TaxiCaller cost code for a client. */
export function buildExpectedCostCode(clientNumber: string, hasHoist: boolean): string {
  const num = normalizeClientNumber(clientNumber);
  if (!num) return "";
  return `${hasHoist ? "TMHClient" : "TMClient"} ${num}`;
}

/** Safe currency. */
export function fmtMoney(n: number | null | undefined): string {
  const v = Number(n ?? 0);
  if (!Number.isFinite(v)) return "$0.00";
  return v.toLocaleString("en-NZ", { style: "currency", currency: "NZD" });
}

/** Safe number. */
export function fmtNum(n: number | null | undefined, digits = 0): string {
  const v = Number(n ?? 0);
  if (!Number.isFinite(v)) return "0";
  return v.toLocaleString("en-NZ", {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  });
}

/** Date (yyyy-mm-dd) -> YYYY-MM */
export function toMonthKey(d: string | null | undefined): string {
  if (!d) return "";
  return String(d).slice(0, 7);
}

/** Always return an array. */
export function safeArr<T>(v: T[] | null | undefined): T[] {
  return Array.isArray(v) ? v : [];
}
